import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { AppApiEndpoints } from '../../app.api.endpoints';
import { HelperProvider } from './helper';



@Injectable()
export class ApiProvider {
	private apiBaseUrl: string;
	private nodes = AppApiEndpoints.nodes;

	constructor(
		private http: HttpClient,
		private helper: HelperProvider,
	) {
		this.apiBaseUrl = environment.API_URL;
	}

	public request({
		url,
		method,
		node,
		data,
		options,
		urlParams,
	}: {
		url?: string,
		method?: string,
		node?: string,
		data?: any,
		options?: any,
		urlParams?: any,
	}): Observable<any> {
		let requestUrl;
		let requestMethod;
		const headers = new HttpHeaders().set('Content-Type', 'application/json');

		if (url && method) {
			if (url.startsWith('http')) {
				requestUrl = url;
			} else {
				requestUrl = this.apiBaseUrl + url;
			}
			requestMethod = method;
		} else if (node) {
			if (typeof this.nodes[node] !== 'undefined') {
				const count = (this.nodes[node].url.match(/:/g) || []).length;
				if (count) {
					if (Object.keys(urlParams).length !== count) {
						const errors: string[] = [];
						errors.push('Url parameters does not match required params.');
						return Observable.throw(errors);
					}
					const urlFields = this.nodes[node].url.split('/');
					for (const paramKey in this.nodes[node].params) {
						urlFields[paramKey] = urlParams[this.nodes[node].params[paramKey]];
					}
					requestUrl = this.apiBaseUrl;
					for (const urlField of urlFields) {
						requestUrl += urlField + '/';
					}
					if (requestUrl.substr(requestUrl.length - 1) === '/') {
						requestUrl = requestUrl.substr(0, requestUrl.length - 1);
					}
				} else {
					requestUrl = this.apiBaseUrl + this.nodes[node].url;
				}
				requestMethod = this.nodes[node].method;

			}
		}
		const defaultRequestOptions = {
			url: requestUrl,
			headers,
		};
		const httpData = data || {};

		const requestOptions = options || defaultRequestOptions;

		if (requestMethod === 'GET') {
			return this.get(requestUrl, httpData, requestOptions);
		} else if (requestMethod === 'POST') {
			return this.post(requestUrl, httpData, requestOptions);
		}
	}



	private get(url: string, data: object, options: any): Observable<any> {
		options.params = data;
		return this.http.get(url, options)
			.map(this.extractData)
			.catch(this.handleError);
	}



	private post(url: string, data: object, options: any): Observable<any> {
		return this.http.post(url, data, options)
			.map(this.extractData)
			.catch(this.handleError);
	}



	private extractData(response: any) {
		console.log('ApiProvider::extractData()', 'response', response);

		return response.data || response || {};
	}



	private handleError(errorResponse: any) {
		const errors: string[] = [];

		if (errorResponse instanceof HttpErrorResponse) {
			const errorsBody = errorResponse.error.errors || [];

			for (const singleError of errorsBody) {
				errors.push(singleError.code);
			}
		} else {
			if (errorResponse.message) {
				errors.push(errorResponse.message);
			} else {
				errors.push(errorResponse.toString());
			}
		}

		return Observable.throw(errors);
	}
}



// WEBPACK FOOTER //
// ./src/app/core/providers/api.ts